"use strict";
// Moderation Database Types
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublishStatus = exports.DatabaseScanResult = exports.ModerationStatus = exports.ScanResultEnum = exports.ModerationSeverity = exports.ContentModerationTypeEnum = void 0;
// ===== ENUMS =====
var ContentModerationTypeEnum;
(function (ContentModerationTypeEnum) {
    ContentModerationTypeEnum["PATTERN"] = "pattern";
    ContentModerationTypeEnum["REVIEW"] = "review";
    ContentModerationTypeEnum["COMMENT"] = "comment";
    ContentModerationTypeEnum["MATERIAL"] = "material";
    ContentModerationTypeEnum["MATERIAL_UPDATE"] = "material_update";
    ContentModerationTypeEnum["MATERIAL_BULK_UPDATE"] = "material_bulk_update";
    ContentModerationTypeEnum["PUBLIC_MATERIAL_UPDATE"] = "public_material_update";
    ContentModerationTypeEnum["PROJECT"] = "project";
    ContentModerationTypeEnum["CRAFT_ROOM"] = "craft_room";
    ContentModerationTypeEnum["CRAFT_ROOM_UPDATE"] = "craft_room_update";
    ContentModerationTypeEnum["PDF"] = "pdf";
})(ContentModerationTypeEnum || (exports.ContentModerationTypeEnum = ContentModerationTypeEnum = {}));
var ModerationSeverity;
(function (ModerationSeverity) {
    ModerationSeverity["WARNING"] = "warning";
    ModerationSeverity["VIOLATION"] = "violation";
})(ModerationSeverity || (exports.ModerationSeverity = ModerationSeverity = {}));
var ScanResultEnum;
(function (ScanResultEnum) {
    ScanResultEnum["PASSED"] = "passed";
    ScanResultEnum["WARNING"] = "warning";
    ScanResultEnum["FAILED"] = "failed";
})(ScanResultEnum || (exports.ScanResultEnum = ScanResultEnum = {}));
// ===== MODERATION QUEUE =====
// Re-export enums as canonical type aliases for backward compatibility
const moderation_status_1 = require("../enums/moderation-status");
Object.defineProperty(exports, "ModerationStatus", { enumerable: true, get: function () { return moderation_status_1.ModerationStatus; } });
const scan_result_1 = require("../enums/scan-result");
Object.defineProperty(exports, "DatabaseScanResult", { enumerable: true, get: function () { return scan_result_1.DatabaseScanResult; } });
const publish_status_1 = require("../enums/publish-status");
Object.defineProperty(exports, "PublishStatus", { enumerable: true, get: function () { return publish_status_1.PublishStatus; } });
